import QRCodeEntityDisplay from './QRCodeEntityDisplay';


export default QRCodeEntityDisplay;